<template>
    <div>
        <ContentHeader path-set-type="append" :gameplan-nav="false" />
        <div class="content-wrapper" v-loading = 'loading'>
            <el-row>
                <div class="mask" v-if="isMask"></div>
                <div class="title" style="margin-top: -20px;">活动主题信息</div>
                <div class="card-box" >
                    <div class="card is-hover-shadow" >
                        <div class="left">
                            <div class="left-top">
                                <div class="left-top-left">
                                    <div class="top-name">{{themeBasic.themeName}}</div>
                                    <div class="top-sign">{{getBluename(themeBasic.orgLevel)}}</div>
                                </div>
                                <div class="left-top-right">
                                    <span>{{getTime(themeBasic.themeStartTime)}}</span>
                                    <span style="margin:0px 10px;">至</span>
                                    <span>{{getTime(themeBasic.themeEndTime)}}</span>
                                </div>
                            </div>
                            <div class="pr-item-flex" v-if="themeDetailInfo.gpPrDTOList">
                              <div style="margin-right:50px;margin-top:12px;"><span class="font-weight-bold">PR信息：</span>{{prInfo}}</div>
                              <div style="margin-top:12px;"><span class="font-weight-bold">品牌信息：</span>{{brandInfo}}</div>
                            </div>
                            <div class="left-third">
                                <div class="left-third-left">
                                    <span>活动执行数据收集模板</span>
                                    <span @click="viewChangepop()" style="color: #409EFF;margin-left: 20px;cursor: pointer;">配置详情</span>
                                </div>
                                <div class="left-third-right">
                                    <span class="text">活动执行手册</span>
                                    <span  class="text" style="color: #409EFF;margin-left: 20px;cursor: pointer;">
                                        <span @click="viewPdf()" v-if="themeBasic.manualFileName && themeBasic.manualFileUri">{{ themeBasic.manualFileName }}</span>
                                        <span v-else>暂无附件</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="title" style="margin-top: 20px;">活动配置信息</div>
                <div class="card-box2 is-hover-shadow" >
                    <div class="form">
                        <div class="item">
                            <div class="item-left">活动渠道</div>
                            <div class="item-right">
                                <span>{{themeChannelName}}</span>
                            </div>
                        </div>
                        <div class="item">
                            <div class="item-left">活动形式</div>
                            <div class="item-right">{{themeStyleName}}</div>
                        </div>
                        <div class="item">
                            <div class="item-left">活动级别</div>
                            <div class="item-right" v-if="themeLevelName">{{themeLevelName}}</div>
                            <div class="item-right" v-else>暂无</div>
                        </div>
                        <div class="item">
                            <div class="item-left">活动时间</div>
                            <div class="item-right" style="display: flex;justify-content: space-between;">
                                <div style="width:80%">
                                    <span>{{getTime(themeBasic.themeStartTime)}}</span>
                                    <span style="margin:0px 10px;">至</span>
                                    <span>{{getTime(themeBasic.themeEndTime)}}</span>
                                </div>
                                <div  @click="collClick('orderShow1')" style="flex:1;color:#409EFF;text-align:left;cursor: pointer;">
                                    <span v-if="!orderShow1">查看更多</span>
                                    <span v-else>收起</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form" style="display:block" v-show="orderShow1">
                        <div class="item-sign">
                            <div class="sign">
                                <div class="sign-left">场勘</div>
                                <div class="sign-right">
                                    <i v-if="checkCK" class="el-icon-success color-green"></i>
                                    <i v-else class="el-icon-error color-red "></i>
                                </div>
                            </div>
                            <div class="sign">
                                <div class="sign-left">搭建</div>
                                <div class="sign-right">
                                    <i v-if="checkDJ" class="el-icon-success color-green"></i>
                                    <i v-else class="el-icon-error color-red"></i>
                                </div>
                            </div>
                            <div class="sign">
                                <div class="sign-left">临促</div>
                                <div class="sign-right">
                                    <i v-if="checkSPR" class="el-icon-success color-green"></i>
                                    <i v-else class="el-icon-error color-red"></i>
                                </div>
                            </div>
                            <div class="sign">
                                <div class="sign-left">转场</div>
                                <div class="sign-right">
                                    <i v-if="needTransitions == 1" class="el-icon-success color-green"></i>
                                    <i v-else class="el-icon-error color-red"></i>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="item" style="width:100%" v-if="getDecorates('showDecorates')">
                            <div class="item-left">搭建点位</div>
                            <div class="item-right" >
                                <span v-if="getDecorates('showDecorates')">{{getDecorates('showDecorates')}}</span>
                            </div>
                        </div>
                        <div class="item" style="width:100%" v-if="getDecorates('showExecDecorates')">
                            <div class="item-left">执行点位</div>
                            <div class="item-right" >
                                <span>{{getDecorates('showExecDecorates')}}</span>
                            </div>
                        </div> -->
                        <div class="item" style="width:100%" v-if="getDecorates('all')">
                            <div class="item-left">点位照片</div>
                            <div class="item-right" >
                                <span>{{getDecorates('all')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="form" v-show="orderShow1">
                        <div class="item">
                            <div class="item-left">单场投入预算</div>
                            <div class="item-right" v-if="investUnit">{{formatPrice(investUnit)}}</div>
                            <div class="item-right" v-else>暂无</div>
                        </div>
                        <div class="item" v-if="needTransitions == 1">
                            <div class="item-left">道具数量</div>
                            <div class="item-right">{{formatPrice(itemQuantity)}}</div>
                        </div>
                        <div class="item" v-else>
                            <div class="item-left">
                                <span v-if="pocRelateType == '1'">每售点执行天数</span>
                                <span v-if ="pocRelateType == '2'">每街区执行天数</span>
                                <span v-if ="pocRelateType == '0'">每活动地点执行天数</span>
                            </div>
                            <div class="item-right">
                                <span>{{formatPrice(perExecDays)}}</span>
                                <span style="margin:0px 0px;">天</span>
                            </div>
                        </div>
                        <div class="item" v-if="themeDetail.needSpr == '1'">
                            <div class="item-left">临促人员人数限制</div>
                            <div class="item-right" v-if="themeDetail.pgQtyLimit">{{ formatPrice(themeDetail.pgQtyLimit) }}</div>
                            <div class="item-right" v-else>暂无</div>
                        </div>
                        <div class="item"  v-if="themeDetail.needSpr == '1'">
                            <div class="item-left">打卡/执行信息上传方式</div>
                            <div class="item-right" v-if="themeDetail.needPerformance == '1'">督导统一上传</div>
                            <div class="item-right" v-else>临促人员自行上传</div>
                        </div>
                        <div class="item" style="width:100%">
                            <div class="item-left">活动SKU</div>
                            <div class="item-right" >
                                <!-- <span>{{getSKU(themeDetail.skuDTOList,'、')}}</span> -->
                                <span v-if=" themeDetail.skuDTOList && themeDetail.skuDTOList.length > 0">
                                    <el-tag
                                        style=" margin:0 10px 8px 0px;cursor: pointer;"
                                        v-for="tag in  themeDetail.skuDTOList"
                                        :key="tag.skuCode"
                                        type="info">
                                        {{tag.skuName}}
                                    </el-tag>
                                </span>
                                <span v-else>暂无数据</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="title" style="margin-top: 20px;">提报要求</div>
                <div class="card-box3 is-hover-shadow" >
                    <div class="form">
                        <div class="item">
                            <div class="item-left">提报售点要求</div>
                            <div class="item-right">
                                <span>{{saleTypename}}</span>
                            </div>
                        </div>
                        <div class="item" v-if="pocRelateType == '2'">
                            <div class="item-left">最少关联售点设置</div>
                            <div class="item-right">{{formatPrice(pocCountMin)}}</div>
                        </div>
                        <div class="item">
                            <div class="item-left">额度信息</div>
                            <div class="item-right">
                                <div v-for="item in themeDetail.detailDTOList" :key="item.regionCode">
                                    <div v-if="item.totalCountQty > 0">
                                        <span style="margin:0px 5px 0px 0px;">{{getRegionName(item.regionName)}}</span>
                                        <span>{{formatPrice(item.totalCountQty)}}{{ showText }}</span>
                                        <span>（已通过：</span>
                                        <span>{{formatPrice(item.passedCountQty)}}{{ showText }}</span>
                                        <span style="margin:0px 5px;">/</span>
                                        <span>审核中：</span>
                                        <span>{{formatPrice(item.approvalCountQty)}}{{ showText }}</span>
                                        <span style="margin:0px 5px;">/</span>
                                        <span>未提报：</span>
                                        <span>{{formatPrice(item.notReportCountQty)}}{{ showText }}</span>
                                        <span>）</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div v-for="item of fullConfig" :key="item.themeChannelCode">
                    <AddPop
                        :channelForm="item"
                        :dataForm ='detailList'
                        :themeBasic="themeBasic"
                        :igniteOptions="igniteOptions"
                        :regionCode="regionCode"
                        @addPopsale="addPopsale"
                        >
                    </AddPop>
                </div> -->
                <div v-if="isShowpop">
                    <AddPop
                        :dataForm ='themeDetailInfo'
                        :themeBasic = 'themeBasic'
                        :igniteOptions="igniteOptions"
                        :regionCode="regionCode"
                        :gpActivityInfoVOList="gpActivityInfoVOList"
                        @addPopsale="addPopsale"
                        >
                    </AddPop>
                </div>
                <div class="photo-bottom">
                    <DialogPop
                    @confirm="passThrough"
                    isType="0"
                    btnText="提报"
                    centerText="是否确认提报？"
                    >
                    </DialogPop>
                </div>
                <div v-if="showChangepop" class="changePop">
                    <configBuChangePop
                    @closeChangepop="closeChangepop"
                    :themeId="themeBasic.themeId"
                    ></configBuChangePop>
                </div>
            </el-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { commonUtils } from '@/utils/common'
    import gameplanApi from '../../api/gameplan'
    import ContentHeader from '@/components/content-header'
    import AddPop from './components/activity-report-add-pop.vue'
    import DialogPop from './components/dialog-pop.vue'
    import configBuChangePop from './components/config-buChange-pop.vue'
    export default {
      name: 'activity-report-add',
      components: {
        ContentHeader,
        AddPop,
        DialogPop,
        configBuChangePop
      },
      data () {
        return {
            isMask: false, // 是否展示蒙层
            tableData: [],
            multipleSelection: [],
            igniteOptions: {
            },
            isSinglepoint: false,
            isManypoint: false,
            channelList:['cross','cr','bar'],
            fullConfig:[],
            themeChannelCodes:[],
            themeBasic: {},
            detailList: {},
            confirmOrSubmit: {},
            applyEmpName: '',
            cityName:'',
            buCode: '',
            regionCode: '',
            searchList:{}, // 单多售点查询相关条件
            salePointlist:[],
            themeDetailId: '',
            activityId:'',
            areaCode: '',
            loading: false,
            checkCK: false, // 场勘
            checkDJ: false, // 搭建
            checkSPR: false, // SPR
            themeDecorates: '', //点位信息
            perExecDays:'', // 执行天数
            pocRelateType:'', // 售点类型
            pocCountMin:'', // 最少关联售点设置
            itemQuantity:'', // 道具数量
            needTransitions:'', // 转场
            saleTypename:'', // 提报售点要求
            investUnit: '', // 单场投入预算
            themeChannelName:'',
            themeStyleName:'',
            themeLevelName:'',
            themeDetail:'',
            themeDetailInfo: {},
            isShowpop:false,
            showChangepop: false,
            congfigDetail:null,// 配置信息
            orderShow1:false,
            orderShow2:true,
            orderShow3:true,
            orderShow4:true,
            gpActivityInfoVOList:[],
            prInfo:'',
            brandInfo:''
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
        showText () {
            if(this.needTransitions == 1) {
                return '场'
            } else {
                if (this.pocRelateType == '1') {
                    return '售点'
                } else if (this.pocRelateType == '0') {
                    return '地点'
                } else if (this.pocRelateType == '2') {
                    return '街区'
                } else {
                    return ''
                }
            }
        }
      },
      watch: {},
      created () {
        this.themeDetailId =this.$route.query.themeDetailId
        this.activityId = this.$route.query.activityId,
        this.areaCode = this.userInfo.areaCode
        this.regionCode = this.userInfo.regionCode
        this.init()
      },
      mounted () {},
      updated () {},
      methods: {
        init () {
            this.getDetailinfo()
        },
        // 金额千分
        formatPrice(price) {
            return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        // 订单明细显示隐藏
        collClick (name) {
            if (name == 'orderShow1') {
                this.orderShow1 = !this.orderShow1
            } else if (name == 'orderShow2') {
                this.orderShow2 = !this.orderShow2
            }
        },

        lockScroll() {
            let widthBar = 17, root = document.documentElement;
            if (typeof window.innerWidth == 'number') {
                widthBar = window.innerWidth - root.clientWidth;
            }
            root.style.overflow = 'hidden';
            root.style.borderRight = widthBar + 'px solid transparent';
        },
        unlockScroll() {
            let root = document.documentElement;
            root.style.overflow = '';
            root.style.borderRight = '';
        },
        viewPdf () {
            if (this.themeBasic.manualFileUri) {
                window.open(commonUtils.getImageUrl(this.themeBasic.manualFileUri))
            } else {
                console.log('manualFileUri为空');
            }
        },
        viewChangepop () {
            this.isMask = true
            this.showChangepop = true
            this.lockScroll()
        },
        closeChangepop () {
            this.isMask = false
            this.showChangepop = false
            this.unlockScroll()
        },
        getSKU (arr,sign) {
            if (arr && arr.length > 0) {
                let name = arr.map((item)=>{
                return item.skuName
                }).join(sign)
                return name
            } else {
                return '暂无数据'
            }
        },
        // 获取check值
        getCheckvalue () {
            let data = this.themeDetail
            // spr
            if (data.needSpr == 1) {
                this.checkSPR = true
            } else {
                this.checkSPR = false
            }
            // 场勘
            if (data.needVerify == 1) {
                this.checkCK = true
            } else {
                this.checkCK = false
            }
            // 搭建
            if (data.needConstruct == 1) {
                this.checkDJ = true
            } else {
                this.checkDJ = false
            }
        },
        // 获取点位信息
        getDecorates (type) {
            let data = this.themeDetail.themeDecorates
            let showDecorates = []
            let showExecDecorates = []
            if (data && this.congfigDetail) {
                if (this.congfigDetail.showDecorates) {
                    for (let item1 of this.congfigDetail.showDecorates) {
                        for (let item2 of data) {
                            if (item2.decorateCode == item1.decorateCode) {
                                showDecorates.push(item2)
                            }
                        }
                    }
                }
                if (this.congfigDetail.showExecDecorates) {
                    for (let item1 of this.congfigDetail.showExecDecorates) {
                        for (let item2 of data) {
                            if (item2.decorateCode == item1.decorateCode) {
                                showExecDecorates.push(item2)
                            }
                        }
                    }
                }

                if (type == 'showDecorates') {
                    if (showDecorates.length > 0) {
                        let name = showDecorates.map((item)=>{
                            return item.decorateName
                        }).join('、')
                        return name
                    } else {
                        return false
                    }
                } else if (type == 'showExecDecorates') {
                    if (showExecDecorates.length > 0) {
                        let name = showExecDecorates.map((item)=>{
                            return item.decorateName
                        }).join('、')
                        return name
                    } else {
                        return false
                    }
                } else if (type == 'all') {
                    if (data.length > 0) {
                        let name = data.map((item)=>{
                            return item.decorateName
                        }).join('、')
                        return name
                    } else {
                        return false
                    }
                } else {
                    return
                }

            } else {
                return ''
            }
        },
        getpocRelateType () {
            this.pocRelateType = this.themeDetail.pocRelateType
            this.pocCountMin = this.themeDetail.pocCountMin
            this.itemQuantity = this.themeDetail.itemQuantity
            this.needTransitions = this.themeDetail.needTransitions
            this.perExecDays = this.themeDetail.perExecDays
            this.investUnit = this.themeDetail.investUnit
            this.themeChannelName = this.themeDetail.themeChannelName&&this.themeDetail.themeChannelName.split('|')[0]
            this.themeStyleName = this.themeDetail.themeStyleName
            this.themeLevelName = this.themeDetail.themeLevelName
            if (this.pocRelateType == 0) {
                return this.saleTypename = '无售点'
            }else if (this.pocRelateType == 1) {
                return this.saleTypename = '单售点'
            } else if (this.pocRelateType == 2) {
                return this.saleTypename = '多售点'
            } else {
                return this.saleTypename = 'error'
            }
        },
        getRegionName (name) {
            if (name) {
                return name.split('|')[0] + ":"
            }else {
                return '无'
            }
        },
        getBluename (name) {
            if (name == 'region') {
                return 'Region'
            } else if (name == 'bu') {
                return 'BU'
            } else if (name == 'hq') {
                return 'HQ'
            } else {
                return 'error'
            }
        },
        getChannel(a,b){
            let themeChannels = a || []
            let arr = themeChannels.map((item) => {
                    return item.themeChannelEnName
                }).join(b)
            return arr
        },
        getTime (timestamp) {
        if (timestamp === 0 || timestamp == null) {
            return ''
        } else {
            var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
            const Y = date.getFullYear() + '-'
            const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
            const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
            // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
            // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
            // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
            return Y + M + D
        }
        },
        getShowDetail(){
          let brandInfo = []
          let prInfo = []
          const gpPrDTOList = this.themeDetailInfo.gpPrDTOList
          if(gpPrDTOList){
            gpPrDTOList.forEach(item=>{
              let data = ''
              if(item.brandName&&item.subBrandName)  data = item.brandName+'-'+item.subBrandName
              else data = item.brandName||item.subBrandName
              if(brandInfo.indexOf(data)===-1) {
                brandInfo.push(data)
              }
              prInfo.push(item.prNumber+'-'+item.prName)
            })
            this.brandInfo = brandInfo.join('、')
            this.prInfo = prInfo.join('、')
          }
        },
        async getDetailinfo () {
            this.loading = true
            let params = {
                activityId:this.activityId,
                'themeDetailId':this.themeDetailId,
                // 'areaCode':this.areaCode,
                // 'regionCode':this.regionCode,
            }
            let {data} = await gameplanApi.getGamepalnDetail(params)
            if (data.resultCode == '0') {
                this.isShowpop = true
                this.loading = false
                // this.themeBasic = data.resultData.themeInfo.themeBasic
                // this.channelList =  data.resultData.themeInfo.themeBasic.themeChannelCodes
                // let fullConfig = data.resultData.themeInfo.themeBasic.themeChannels
                // this.detailList = data.resultData.themeInfo.detailList
                this.themeDetailInfo = data.resultData.themeDetailInfo || {}
                this.themeBasic = data.resultData.themeDetailInfo.themeBasic || {}
                this.themeDetail = data.resultData.themeDetailInfo.themeDetail || {}
                if(!data.resultData.themeDetailInfo.themeDetail) this.$message.error("数据异常")
                this.gpActivityInfoVOList = data.resultData.themeDetailInfo.gpActivityInfoVOList || []
                this.getConfigfull()
                this.getCheckvalue()
                this.getpocRelateType()
                this.getShowDetail()
                // let arr = []
                // for (const item of this.detailList) {
                //     arr.push(item.themeDetail.themeChannelCode)
                // }
                // let newArr = [...new Set(arr)]
                // let fullConfignew = []
                // for (let item1 of fullConfig) {
                //     for (let item2 of newArr) {
                //         if (item1.themeChannelCode == item2) {
                //             fullConfignew.push(item1)
                //         }
                //     }
                // }
                // this.fullConfig = fullConfignew
            } else {
                this.loading = false
            }
        },
        // 城市提报
        async activityReport (params) {
            let {data} = await gameplanApi.getGamepalnActivityreport(params)
            if (data.resultCode == '0') {
                this.loading = false
                this.$message.success("当前售点提报成功")
                this.$router.go(-2)
            } else {
                this.loading = false
            }
        },
        // 获取配置信息
        async getConfigfull () {
            let {data} = await gameplanApi.getGameplanConfigFull()
            if (data.resultCode == '0') {
                let fullConfig = data.resultData.fullConfig
                for (let item1 of fullConfig) {
                    if (item1.themeChannelCode == this.themeDetail.themeChannelCode) {
                        for (let item2 of item1.themeStyles) {
                            if (item2.themeStyleCode == this.themeDetail.themeStyleCode) {
                                if (this.themeDetail.themeLevelCode && item2.themeLevels.length > 0) {
                                    for (let item3 of item2.themeLevels) {
                                        if (item3.themeLevelCode == this.themeDetail.themeLevelCode) {
                                            this.congfigDetail = item3.themeConfig
                                        }
                                    }
                                } else {
                                    this.congfigDetail = item2.themeConfig
                                }
                            }
                        }
                    }
                }
            }
        },
        // 关闭dialog
        closeDialog () {
            this.isMask = false
        },
        clickStorename (row) {
            this.$router.push({name:'submit-salePlace-detail',query:{a:row}})
        },
        addPopsale(item) {
            if (item[0].gpActivityInfoDTO.isEmptyvalue == true) {
                for (let j = 0; j < this.salePointlist.length;j++) {
                    if (item[0].gpActivityInfoDTO.themeLevelCode == null) {
                        if (this.salePointlist[j].gpActivityInfoDTO.themeStyleCode === item[0].gpActivityInfoDTO.themeStyleCode) {
                            this.salePointlist.splice(j, 1)
                            j--
                        }
                    } else {
                        if (this.salePointlist[j].gpActivityInfoDTO.themeLevelCode === item[0].gpActivityInfoDTO.themeLevelCode) {
                            this.salePointlist.splice(j, 1)
                            j--
                        }
                    }
                }
            } else {
                let a = []
                for (let i of item) {
                    a.push(i)
                }
                if (this.salePointlist.length > 0  && a.length > 0) {
                    for (let j = 0; j < this.salePointlist.length;j++) {
                        if (a[0].gpActivityInfoDTO.themeLevelCode == null) {
                            if (this.salePointlist[j].gpActivityInfoDTO.themeStyleCode === a[0].gpActivityInfoDTO.themeStyleCode) {
                                this.salePointlist.splice(j, 1)
                                j--
                            }
                        } else {
                            if (this.salePointlist[j].gpActivityInfoDTO.themeLevelCode === a[0].gpActivityInfoDTO.themeLevelCode) {
                                this.salePointlist.splice(j, 1)
                                j--
                            }
                        }
                    }
                }
                this.salePointlist = this.salePointlist.concat(a)
            }
            // console.log('addPopsale', this.salePointlist);
        },
        // 提报
        passThrough () {
            let arr = {
                "activityInfoVOList": this.salePointlist
            }
            if(this.activityId) arr.activityId = this.activityId
            this.loading = true
            this.activityReport(arr)
        }
    }
}
</script>
<style lang="scss" scoped>
    .is-hover-shadow:hover {
        box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
    .mask{
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0,0,0,.7) ;
        z-index: 3;
    }
    .content-wrapper {
        min-height: calc(100vh - 320px) !important;
        font-family: SourceHanSansSC-regular;
        .title {
            line-height: 40px;
            text-align: left;
            color: #101010;
            font-size: 18px;
            font-weight: 600;
        }
        .card-box {
            .card {
                padding: 10px 20px 10px 20px;
                background-color: #FFFFFF ;
                border-radius: 8px;
                font-size: 14px;
                .left {
                    text-align: left;
                    color: #101010;
                    .left-top {
                        display: flex;
                        .left-top-left {
                            width: 70%;
                            font-size: 18px;
                            display: flex;
                            .top-name {
                                // padding: 2px 0px;
                                font-weight: 600;
                                word-wrap: break-word;
                                word-break: normal;
                                word-break: break-all;
                            }
                            .top-sign {
                                // padding: 2px 8px;
                                color: #FFFFFF;
                                background-color: #40A5EE;
                                margin-left: 10px;
                                // border-radius: 3px;
                                // height: 20px;
                                padding: 0px 8px;
                                line-height: 18px;
                                height: 18px;
                                font-size: 14px;
                                margin-top: 1px;
                                font-weight: 600;
                            }
                        }
                        .left-top-right {
                            flex: 1;
                            line-height: 20px;
                            font-size: 14px;
                            text-align: right;
                            word-wrap: break-word;
                            word-break: normal;
                            word-break: break-all;
                        }
                    }
                    .fouth {
                        font-size: 14px;
                        line-height: 20px;
                        color: #101010 ;
                        margin-top: 15px;
                        display: flex;
                        .fouth-left {
                            display: flex;
                            .first-center {
                                height: 15px;
                                line-height: 15px;
                                padding: 3px 10px;
                                text-align: center;
                                border-radius: 4px;
                                border: 1px solid #539EFE;
                                background-color: #FFFFFF;
                                color: #539EFE;
                                margin-left: 20px;
                                margin-top: -1px;
                            }
                        }
                        .fouth-right {
                            // color: #999999 ;
                            flex: 1;
                            margin-left: 50px;

                        }
                    }
                    .left-third {
                        font-size: 14px;
                        height: 20px;
                        line-height: 20px;
                        margin-top: 12px;
                        display: flex;
                        justify-content: flex-start;
                        .left-third-left {
                            display: flex;
                            justify-content: flex-start;
                            margin-right: 80px;
                        }
                        .left-third-right {
                            display: flex;
                            justify-content: flex-start;
                            .img {
                            width: 20px;
                            margin-right: 3px;
                            }
                            // .text {
                            //     margin: 0px 3px 0px 3px ;
                            //     // color: #539EFE;
                            // }
                        }
                    }
                    .left-fouth {
                        display: flex;
                        font-size: 14px;
                        line-height: 20px;
                        margin-top: 12px;
                        .left-fouth-left {
                            width: 70px;
                        }
                        .left-fouth-right {
                            flex: 1;
                        }
                    }
                }
            }
        }
        .card-box2 {
            padding: 10px 20px;
            background-color: #FFFFFF;
            color: #101010;
            border-radius: 10px;
            .form{
                display: flex;
                flex-wrap: wrap;
                padding-left: 8px;
                .item {
                    width: 50%;
                    line-height: 33px;
                    font-size: 14px;
                    color: #101010;
                    display: flex;
                    text-align: left;
                    .item-left {
                        text-align: right;
                        width: 148px;
                        font-weight: 600;
                        margin-right: 40px;
                    }
                    .item-right {
                        flex: 1;
                        word-wrap: break-word;
                        word-break: normal;
                        word-break: break-all;
                    }
                }
                .item-sign {
                    line-height: 33px;
                    font-size: 14px;
                    color: #101010;
                    display: flex;
                    text-align: left;
                    padding-left: 104px;
                    .sign {
                        display: flex;
                        margin: 0px 15px;
                        .sign-left {
                            margin-right: 5px;
                            font-weight: normal;
                            line-height: 33px;
                        }
                        .sign-right {
                            margin-top: 3px;
                            .color-green {
                                color: rgb(42, 219, 33);
                                font-size: 18px;
                            }
                            .color-red {
                                color: rgb(219, 93, 33);
                                font-size: 18px;
                            }
                        }

                    }
                }
            }
        }
        .card-box3 {
            padding: 10px 20px;
            background-color: #FFFFFF;
            color: #101010;
            border-radius: 10px;
            .form{
                padding-left: 8px;
                .item {
                    line-height: 33px;
                    font-size: 14px;
                    color: #101010;
                    display: flex;
                    text-align: left;
                    .item-left {
                        text-align: right;
                        width: 127px;
                        font-weight: 600;
                        margin-right: 40px;
                    }
                    .item-right {
                        flex: 1;
                        word-wrap: break-word;
                        word-break: normal;
                        word-break: break-all;
                    }
                }
            }
        }
        .photo-bottom {
            display: flex;
            justify-content: center;
            margin-top: 100px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            text-align: center;
        }
    }
    .dialog {
        position: fixed;
        top: 5%;
        left: calc((100vw - 840px)/2);
        width: 800px;
        // height: 300px;
        padding: 20px;
        background-color: #FFFFFF;
        border-radius: 8px;
        z-index: 3;
    }
    .changePop {
        position: fixed;
        top: 5vh;
        left: calc((100vw - 800px)/2);
        width: 800px;
        padding: 20px;
        background-color: #FFFFFF;
        border-radius: 10px;
        z-index: 3;
        max-height: 90vh;
    }
    .mask{
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0,0,0,.7) ;
        z-index: 3;
    }
  .pr-item-flex{
    display:flex;
    flex-wrap:wrap;
  }
</style>
